var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 173.388L129.461 82.718H70.5391L99.9997 173.388H100Z",
    fill: "#E24329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 173.387L70.5387 82.7172H29.251L100 173.387Z",
    fill: "#FC6D26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2511 82.7172L20.2986 110.272C19.9005 111.496 19.9005 112.816 20.2984 114.041C20.6964 115.266 21.4719 116.334 22.5139 117.091L100 173.388L29.2505 82.7178L29.2511 82.7172Z",
    fill: "#FCA326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 82.7176H70.5387L52.7956 28.1073C51.8825 25.2972 47.9072 25.2979 46.9947 28.1073L29.251 82.7176Z",
    fill: "#E24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 173.387L129.461 82.7172H170.749L99.9995 173.387H100Z",
    fill: "#FC6D26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.749 82.7172L179.701 110.272C180.099 111.497 180.099 112.816 179.701 114.041C179.303 115.266 178.528 116.334 177.485 117.091L100 173.388L170.749 82.7178V82.7172Z",
    fill: "#FCA326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.749 82.7176H129.461L147.205 28.1073C148.118 25.2972 152.093 25.2979 153.006 28.1073L170.749 82.7176Z",
    fill: "#E24329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.c9cb37e5ad123a7a9e93047c7e8fca45.svg";
export { ForwardRef as ReactComponent };